export default {
  VEHICLE_CATEGORIES_CONTAINER_CLASS: 'product-section--container',
  VERIFY_FITMENT_NOT_FIT:
    "This Product DOES NOT Fit Your Vehicle<br /><a href='/pages/contact' target='_blank'> Contact Us </a> for Fitment Details",
};
